import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRight } from 'lucide-react';
interface CTAButtonProps {
  text?: string;
  onClick?: () => void;
  className?: string;
}
export function CTAButton({
  text = '¡SÍ, QUIERO DESINFLAMARME AHORA!',
  onClick,
  className = ''
}: CTAButtonProps) {
  return <motion.button whileHover={{
    scale: 1.02
  }} whileTap={{
    scale: 0.98
  }} animate={{
    boxShadow: ['0px 0px 0px 0px rgba(232, 93, 58, 0.4)', '0px 0px 0px 15px rgba(232, 93, 58, 0)', '0px 0px 0px 0px rgba(232, 93, 58, 0)']
  }} transition={{
    boxShadow: {
      repeat: Infinity,
      duration: 2
    },
    scale: {
      type: 'spring',
      stiffness: 400,
      damping: 10
    }
  }} onClick={() => {
    if (onClick) {
      onClick();
    } else {
      document.getElementById('oferta')?.scrollIntoView({
        behavior: 'smooth'
      });
    }
  }} className={`relative inline-flex items-center justify-center gap-2 bg-cta text-white font-bold text-lg md:text-xl py-4 px-8 rounded-full shadow-lg hover:bg-opacity-90 transition-colors w-full md:w-auto cursor-pointer ${className}`} data-id="element-37">
      <span data-id="element-38">{text}</span>
      <ArrowRight className="w-5 h-5 md:w-6 md:h-6" data-id="element-39" />
    </motion.button>;
}